"use client";

import { motion } from "framer-motion";
import { CandlestickChart, CircleCheckBig } from "lucide-react";
import { getViewModeChrome } from "../view-mode-chrome";

interface FastForwardSuccessProps {
  barsAdded?: number;
  viewMode?: string;
}

export function FastForwardSuccess({ barsAdded = 0, viewMode}: FastForwardSuccessProps) {
  const chrome = getViewModeChrome(viewMode);
  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.98 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.2, ease: "easeOut" }}
      className="w-full"
    >
      <div className={`rounded-md border ${chrome.card} overflow-hidden`}>
        <div className="px-3 py-2 flex items-center justify-between gap-3 min-w-0">
          <div className="flex items-center gap-2.5">
            <CandlestickChart
                className={`w-3.5 h-3.5 ${chrome.iconMuted} shrink-0`}
                strokeWidth={2}
              />
            <div className="flex flex-col">
              <span className={`text-[13px] font-semibold ${chrome.text} truncate`}>
                Price action replayed
              </span>
              <span className={`text-[11px] ${chrome.subtext} truncate`}>
                {barsAdded > 0 ? `Added ${barsAdded} new bars` : 'Chart updated successfully'}
              </span>
            </div>
          </div>
          <motion.div
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            transition={{ delay: 0.1, type: "spring", stiffness: 300 }}
          >
            <CircleCheckBig className="h-4 w-4 text-green-500" />
          </motion.div>
        </div>
      </div>
    </motion.div>
  );
}
